// import React from "react";
// import "./RegisterAndLogin.css";
// import { FaUserAlt } from "react-icons/fa";
// import { IoLockClosedSharp } from "react-icons/io5";
// import { FaGoogle } from "react-icons/fa";
// import { FaFacebookF } from "react-icons/fa";
// import { FaEnvelope } from "react-icons/fa";
// import { useState } from "react";
// import { SignedOut, SignInButton } from "@clerk/clerk-react";

// const RegisterAndLogin = () => {
//   const [isActive, setisActive] = useState(false);

//   const handleGoogleSignIn = () => {
//     document.getElementById("google-sign-in-btn")?.click();
//   };

//   return (
//     <div className="RegisterAndLogin">
//       <div className={`RegisterAndLogin_container ${isActive ? "active" : ""}`}>
//         <div className="form-box login">
//           <form action="">
//             <h1>Login</h1>
//             <div className="input-box">
//               <input
//                 type="text"
//                 placeholder="Username"
//                 required
//                 autoComplete="off"
//               />
//               <FaUserAlt className="Icon" />
//             </div>
//             <div className="input-box">
//               <input
//                 type="password"
//                 placeholder="Password"
//                 required
//                 autoComplete="off"
//               />
//               <IoLockClosedSharp className="Icon" />
//             </div>
//             <div className="forgot-link">
//               <a href="#/">Forgot Password?</a>
//             </div>
//             <button type="submit" className="btn">
//               Login
//             </button>
//             <p>or login with social platforms</p>
//             <div className="social-icons">
//               <a href="#/">
//                 <FaGoogle className="googleIcon" onClick={handleGoogleSignIn} />
//               </a>
//               <a href="#/">
//                 <FaFacebookF className="facebookIcon" />
//               </a>

//               <SignedOut>
//                 <SignInButton
//                   id="google-sign-in-btn"
//                   style={{ display: "none" }}
//                 />
//               </SignedOut>
//             </div>
//           </form>
//         </div>

//         <div className="form-box register">
//           <form action="">
//             <h1>Registration</h1>
//             <div className="input-box">
//               <input
//                 type="text"
//                 name="username"
//                 placeholder="Username"
//                 required
//                 autoComplete="off"
//               />
//               <FaUserAlt className="Icon" />
//             </div>
//             <div className="input-box">
//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Email"
//                 required
//                 autoComplete="off"
//               />
//               <FaEnvelope className="Icon" />
//             </div>

//             <div className="input-box">
//               <input
//                 type="password"
//                 placeholder="Password"
//                 required
//                 autoComplete="off"
//               />
//               <IoLockClosedSharp className="Icon" />
//             </div>

//             <button type="submit" className="btn">
//               Register
//             </button>
//             <p>or register with social platforms</p>
//             <div className="social-icons">
//               <a href="#/">
//                 <FaGoogle className="googleIcon" onClick={handleGoogleSignIn} />
//               </a>
//               <a href="#/">
//                 <FaFacebookF className="facebookIcon" />
//               </a>
//             </div>
//           </form>
//         </div>

//         <div className="toggle-box">
//           <div className="toggle-panel toggle-left">
//             <h1>Hello, Welcome!</h1>
//             <p>Don't have an account?</p>
//             <button
//               className="btn register-btn"
//               onClick={() => setisActive(true)}
//             >
//               Register
//             </button>
//           </div>
//           <div className="toggle-panel toggle-right">
//             <h1>Welcome Back</h1>
//             <p>Already have an account?</p>
//             <button
//               className="btn login-btn"
//               onClick={() => setisActive(false)}
//             >
//               Login
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RegisterAndLogin;

import React, { useState, useEffect } from "react";
import "./RegisterAndLogin.css";
import { FaUserAlt, FaGoogle, FaFacebookF, FaEnvelope } from "react-icons/fa";
import { IoLockClosedSharp } from "react-icons/io5";
import { SignedOut, SignInButton } from "@clerk/clerk-react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

// import {  useGoogleLogin } from "@react-oauth/google";

const RegisterAndLogin = () => {
  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  // const googleLoginRef = useRef(null);

  // Login form state
  const [loginForm, setLoginForm] = useState({
    email: "",
    password: "",
  });

  // Register form state
  const [registerForm, setRegisterForm] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  // Validation states
  const [loginErrors, setLoginErrors] = useState({});
  const [registerErrors, setRegisterErrors] = useState({});

  // Clear messages after 5 seconds
  useEffect(() => {
    if (errorMessage || successMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
        setSuccessMessage("");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage, successMessage]);

  // Handle Google Sign In
  // const handleGoogleSignIn = () => {
  //   document.getElementById("google-sign-in-btn")?.click();
  // };

  // const handleGoogleSignIn = () => {
  //   if (googleLoginRef.current) {
  //     googleLoginRef.current.click();
  //   }
  // };

  // Handle Login Form Changes
  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginForm({
      ...loginForm,
      [name]: value,
    });

    // Clear errors when typing
    if (loginErrors[name]) {
      setLoginErrors({
        ...loginErrors,
        [name]: "",
      });
    }
  };

  // Handle Register Form Changes
  const handleRegisterChange = (e) => {
    const { name, value } = e.target;
    setRegisterForm({
      ...registerForm,
      [name]: value,
    });

    // Clear errors when typing
    if (registerErrors[name]) {
      setRegisterErrors({
        ...registerErrors,
        [name]: "",
      });
    }
  };

  // Validate Login Form
  const validateLoginForm = () => {
    const errors = {};

    if (!loginForm.email.trim()) {
      errors.email = "email is required";
    }

    if (!loginForm.password) {
      errors.password = "Password is required";
    } else if (loginForm.password.length < 6) {
      errors.password = "Password must be at least 6 characters";
    }

    setLoginErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Validate Register Form
  const validateRegisterForm = () => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!registerForm.username.trim()) {
      errors.username = "Username is required";
    } else if (registerForm.username.length < 3) {
      errors.username = "Username must be at least 3 characters";
    }

    if (!registerForm.email.trim()) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(registerForm.email)) {
      errors.email = "Invalid email format";
    }

    if (!registerForm.password) {
      errors.password = "Password is required";
    } else if (registerForm.password.length < 6) {
      errors.password = "Password must be at least 6 characters";
    }

    if (!registerForm.confirmPassword) {
      errors.confirmPassword = "Please confirm your password";
    } else if (registerForm.password !== registerForm.confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
    }

    setRegisterErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Handle Login Submit
  const handleLoginSubmit = async (e) => {
    e.preventDefault();

    if (!validateLoginForm()) {
      return;
    }

    setIsLoading(true);
    setErrorMessage("");

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_KEY}/users/login`, loginForm);
      console.log(response)

      // localStorage.setItem("token", response.data.access_token);
      const token = jwtDecode(response.data.access_token);
      localStorage.setItem("userId", token.Id);
      localStorage.setItem("username", token.username);
      const storedAccessToken = localStorage.getItem("AccessToken");
      setSuccessMessage("Login successful! Redirecting...");
      localStorage.removeItem("selectedImageUrl")
      setTimeout(() => {
        window.location.href = `/${storedAccessToken}`;
      }, 1500);
    } catch (error) {
      console.error("Login error:", error);
      setErrorMessage(
        error.response?.data?.message || "Login failed. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  // Handle Register Submit
  const handleRegisterSubmit = async (e) => {
    e.preventDefault();

    if (!validateRegisterForm()) {
      return;
    }

    setIsLoading(true);
    setErrorMessage("");

    try {
      // const response = await , {
      let url = `${process.env.REACT_APP_API_KEY}/users/signup`;
      const response = await axios.post(url, {
        username: registerForm.username,
        email: registerForm.email,
        password: registerForm.password,
      });
      console.log(response);

      setSuccessMessage("Registration successful! Please login.");

      // Switch to login form after successful registration
      setTimeout(() => {
        setIsActive(false);
        setRegisterForm({
          username: "",
          email: "",
          password: "",
          confirmPassword: "",
        });
      }, 1500);
    } catch (error) {
      console.error("Registration error:", error);
      setErrorMessage(
        error.response?.data?.message ||
        "Registration failed. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  // const login = useGoogleLogin({
  //   onSuccess: async (credentialResponse) => {
  //     try {
  //       const response = await axios.get(
  //         "https://www.googleapis.com/oauth2/v3/userinfo",
  //         {
  //           headers: {
  //             Authorization: `Bearer ${credentialResponse.access_token}`,
  //           },
  //         }
  //       );
  //       console.log(response);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   },
  // });

  return (
    <div className="RegisterAndLogin">
      <div className={`RegisterAndLogin_container ${isActive ? "active" : ""}`}>
        {errorMessage && <div className="error-message">{errorMessage}</div>}

        {successMessage && (
          <div className="success-message">{successMessage}</div>
        )}

        <div className="form-box login">
          <form onSubmit={handleLoginSubmit}>
            <h1>Login</h1>
            <div className="input-box">
              <input
                type="text"
                name="email"
                placeholder="email"
                value={loginForm.email}
                onChange={handleLoginChange}
                autoComplete="off"
              />
              <FaUserAlt className="Icon" />
              {loginErrors.email && (
                <div className="error-text">{loginErrors.email}</div>
              )}
            </div>
            <div className="input-box">
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={loginForm.password}
                onChange={handleLoginChange}
                autoComplete="off"
              />
              <IoLockClosedSharp className="Icon" />
              {loginErrors.password && (
                <div className="error-text">{loginErrors.password}</div>
              )}
            </div>
            <div className="forgot-link">
              <a href="/forgot-password">Forgot Password?</a>
            </div>
            <button type="submit" className="btn" disabled={isLoading}>
              {isLoading ? "Logging in..." : "Login"}
            </button>
            <p>or login with social platforms</p>
            <div className="social-icons">
              <a
                href="#/"
                onClick={(e) => {
                  e.preventDefault();
                  // handleGoogleSignIn();
                  // login();
                }}
              >
                <FaGoogle className="googleIcon" />
              </a>
              <a
                href="#/"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                <FaFacebookF className="facebookIcon" />
              </a>

              {/* <div style={{ display: "none" }}>
                <GoogleLogin
                  ref={googleLoginRef}
                  onSuccess={(credentialResponse) => {
                    console.log(credentialResponse);
                  }}
                  onError={() => {
                    console.log("Login Failed");
                  }}
                />
              </div> */}
              <SignedOut>
                <SignInButton
                  id="google-sign-in-btn"
                  style={{ display: "none" }}
                />
              </SignedOut>
            </div>
          </form>
        </div>

        <div className="form-box register">
          <form onSubmit={handleRegisterSubmit}>
            <h1>Registration</h1>
            <div className="input-box">
              <input
                type="text"
                name="username"
                placeholder="Username"
                value={registerForm.username}
                onChange={handleRegisterChange}
                autoComplete="off"
              />
              <FaUserAlt className="Icon" />
              {registerErrors.username && (
                <div className="error-text">{registerErrors.username}</div>
              )}
            </div>
            <div className="input-box">
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={registerForm.email}
                onChange={handleRegisterChange}
                autoComplete="off"
              />
              <FaEnvelope className="Icon" />
              {registerErrors.email && (
                <div className="error-text">{registerErrors.email}</div>
              )}
            </div>

            <div className="input-box">
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={registerForm.password}
                onChange={handleRegisterChange}
                autoComplete="off"
              />
              <IoLockClosedSharp className="Icon" />
              {registerErrors.password && (
                <div className="error-text">{registerErrors.password}</div>
              )}
            </div>

            <div className="input-box">
              <input
                type="password"
                name="confirmPassword"
                placeholder="Confirm Password"
                value={registerForm.confirmPassword}
                onChange={handleRegisterChange}
                autoComplete="off"
              />
              <IoLockClosedSharp className="Icon" />
              {registerErrors.confirmPassword && (
                <div className="error-text">
                  {registerErrors.confirmPassword}
                </div>
              )}
            </div>

            <button type="submit" className="btn" disabled={isLoading}>
              {isLoading ? "Registering..." : "Register"}
            </button>
            <p>or register with social platforms</p>
            <div className="social-icons">
              <a
                href="#/"
                onClick={(e) => {
                  e.preventDefault();
                  // handleGoogleSignIn();
                  // login();
                }}
              >
                <FaGoogle className="googleIcon" />
              </a>
              <a
                href="#/"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                <FaFacebookF className="facebookIcon" />
              </a>
            </div>
          </form>
        </div>

        <div className="toggle-box">
          <div className="toggle-panel toggle-left">
            <h1>Hello, Welcome!</h1>
            <p>Don't have an account?</p>
            <button
              className="btn register-btn"
              onClick={() => setIsActive(true)}
            >
              Register
            </button>
          </div>
          <div className="toggle-panel toggle-right">
            <h1>Welcome Back</h1>
            <p>Already have an account?</p>
            <button
              className="btn login-btn"
              onClick={() => setIsActive(false)}
            >
              Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterAndLogin;
